import { useEffect, useRef, type ComponentProps } from "react";

/** Follow rendered messages and typing indicators within the thread itself. */
export function HandlerScrollThread(props: ComponentProps<"div">) {
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const thread = ref.current;
    if (!thread) return;
    let frame = 0;
    const follow = () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => {
        const reduced = window.matchMedia?.(
          "(prefers-reduced-motion: reduce)",
        ).matches;
        thread.scrollTo?.({
          top: thread.scrollHeight,
          behavior: reduced ? "auto" : "smooth",
        });
      });
    };
    const observer = new MutationObserver(follow);
    observer.observe(thread, {
      childList: true,
      subtree: true,
      characterData: true,
    });
    follow();
    return () => {
      observer.disconnect();
      cancelAnimationFrame(frame);
    };
  }, []);
  return <div {...props} ref={ref} />;
}
